var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewPermission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#39393C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7778 16C17.7778 16.9813 16.9831 17.7778 16 17.7778C15.0178 17.7778 14.2222 16.9813 14.2222 16C14.2222 15.0187 15.0178 14.2222 16 14.2222C16.9831 14.2222 17.7778 15.0187 17.7778 16ZM16 19.5556C12.4444 19.5556 10.6667 16 10.6667 16C10.6667 16 12.4444 12.4444 16 12.4444C19.5556 12.4444 21.3333 16 21.3333 16C21.3333 16 19.5556 19.5556 16 19.5556ZM21.3333 8H10.6667C9.19374 8 8 9.19374 8 10.6667V21.3333C8 22.8063 9.19374 24 10.6667 24H21.3333C22.8063 24 24 22.8063 24 21.3333V10.6667C24 9.19374 22.8063 8 21.3333 8Z",
    fill: "#FF9747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPermission);
export default __webpack_public_path__ + "static/media/view_permission.0914e8c4eeb711d2b2369de5bc0bf1b8.svg";
export { ForwardRef as ReactComponent };